import React from 'react';
import Link from '@mui/material/Link';
import { string, oneOf, oneOfType, node, shape } from 'prop-types';
import { LinkWrapper } from './Hyperlink.styles';
export const Hyperlink = _ref => {
  let {
    href,
    children,
    target,
    onClick,
    sx
  } = _ref;
  const handleClick = event => {
    if (href && href !== '') return null;
    event.preventDefault();
    return onClick(event);
  };
  const renderMuiLink = () => /*#__PURE__*/React.createElement(Link, {
    style: sx,
    "data-test-id": "link",
    href: href,
    target: target,
    rel: target === '_blank' ? 'noopener noreferrer' : ''
  }, children);
  const renderCustomLink = () => /*#__PURE__*/React.createElement("button", {
    style: sx,
    type: "button",
    className: "hyperlink-button",
    onClick: event => handleClick(event)
  }, children);
  return /*#__PURE__*/React.createElement(LinkWrapper, null, href && href !== '' ? renderMuiLink() : renderCustomLink());
};
Hyperlink.propTypes = {
  children: oneOfType([node, string]).isRequired,
  target: oneOf(['_self', '_blank']),
  href: props => {
    return !props.href && !props.onClick && new Error('One of props "href" or "onClick" was not specified.');
  },
  onClick: props => {
    return !props.href && !props.onClick && new Error('One of props "href" or "onClick" was not specified.');
  },
  sx: shape({})
};
Hyperlink.defaultProps = {
  target: '_self',
  href: '',
  onClick: () => {},
  sx: {}
};